import React, { useState, useEffect } from 'react';
import '../../Styles/ImageModal.css';
import { useAttachmentContext } from '../../contexts/AttachmentContext';

const ImageModal: React.FC = () => {
  const { imageModalState, closeImageModal } = useAttachmentContext();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [imageError, setImageError] = useState<boolean>(false);

  const isFile = !/^https?:\/\//i.test(imageModalState.url);

  useEffect(() => {
    return () => {
      if (imageModalState.url) {
        URL.revokeObjectURL(imageModalState.url);
      }
    };
  }, [imageModalState.url]);

  if (!imageModalState.isOpen) return null;

  return (
    <div className="image-modal-overlay" onClick={closeImageModal}>
      <div className="image-modal-container" onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        closeImageModal();
      }}>
        <div className="image-modal-content">
          {isFile ? (
            // If the URL is a file, just render the image directly.
            <img
              src={imageModalState.url}
              alt="Modal content"
              className="modal-image"
              onClick={(e) => {
                e.stopPropagation();
                closeImageModal();
              }}
            />
          ) : (
            // Otherwise, handle the loading and error states.
            <>
              {isLoading && <div className="image-loading" />}
              {imageError ? (
                <div className="image-error-message">
                  Unable to load image
                </div>
              ) : (
                <img
                  src={imageModalState.url}
                  alt="Modal content"
                  className="modal-image"
                  onClick={(e: React.MouseEvent) => {
                    e.stopPropagation();
                  }}
                  onLoad={() => {
                    setIsLoading(false);
                    setImageError(false);
                  }}
                  onError={() => {
                    setIsLoading(false);
                    setImageError(true);
                  }}
                />
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ImageModal;
